import { common } from '../../main/common-sidecar'
import { voyageGameMode_editor } from './voyageGameMode_editor-sidecar'
import { voyageGameMode_game } from './voyageGameMode_game-sidecar'
import { voyageGameMode_menuMain } from './voyageGameMode_menuMain-sidecar'

export type VoyageGameModeType = 'init' | 'main-menu' | 'game' | 'editor'

export interface IVoyageGameModeManager {
  isPaused: boolean
  generator: Generator<number, number, number> | null
  generator_exit: (() => void) | null
  generatorPauseSeconds: number
  mode: VoyageGameModeType
}

let _obj: IVoyageGameModeManager | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

export function togglePause() {
  get().isPaused = !get().isPaused
}

function create() {
  let obj: IVoyageGameModeManager = {
    generator: null,
    generator_exit: null,
    generatorPauseSeconds: 0,
    isPaused: false,
    mode: 'init',
  }
  return obj
}

export function update() {
  let obj = get()

  let ds = common.getUpdateDeltaScaled()

  if (obj.generatorPauseSeconds > 0) {
    obj.generatorPauseSeconds -= ds
    return
  }

  if (obj.generator) {
    let generatorResult = obj.generator.next()
    if (generatorResult.done) {
      console.log('Generator is done!')
    } else {
      obj.generatorPauseSeconds = generatorResult.value
    }
  }
}

function switchMode(
  newMode: VoyageGameModeType,
  generator: Generator<number, number, number> | null,
  generatorExit: () => void = () => {},
) {
  let obj = get()
  exitCurrentMode()
  obj.mode = newMode
  obj.generator = generator
  obj.generator_exit = generatorExit
}

function exitCurrentMode() {
  let obj = get()
  if (obj.generator_exit) {
    obj.generator_exit()
    obj.generator_exit = null
  }
}

export function goMenuMain() {
  switchMode('main-menu', voyageGameMode_menuMain.generator_menuMain())
}
export function goEditor() {
  switchMode('editor', voyageGameMode_editor.generator_editor())
}
export function goGame() {
  switchMode('game', voyageGameMode_game.generator_game())
}
